import { getIntl } from 'utils/getTranslations';
import { isNewDesignCopy } from 'utils/newDesignCopy';

const dayMonth = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short' });
const dayMonthYear = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });

/** `1 Jan – 14 Oct 2026`: the stretch of a year from its first day to the day of `until`, as one range of the locale's. */
export function yearToDateRange(until: Date): string {
    if (isNewDesignCopy()) {
        return getIntl().formatDateTimeRange(new Date(until.getFullYear(), 0, 1), until, {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
        });
    }
    return `${dayMonth.format(new Date(until.getFullYear(), 0, 1))} – ${dayMonthYear.format(until)}`;
}

/** The same day a year before `today`, the end of last year to date. */
export function sameDayLastYear(today: Date): Date {
    const date = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate());
    // 29 February has no match a year earlier: the database steps back to the 28th, and so does this.
    return date.getMonth() === today.getMonth() ? date : new Date(today.getFullYear() - 1, today.getMonth() + 1, 0);
}
